import { motion } from "framer-motion";
import { COST_COMPARISON } from "@/data/content";

export const CostComparison = () => (
  <section data-testid="cost-comparison-section" className="bg-baseLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl lg:mx-auto lg:max-w-none lg:text-center"
      >
        <h2
          data-testid="cost-comparison-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:whitespace-nowrap lg:text-[36px]"
        >
          Compare the complete energy picture
        </h2>
        <p data-testid="cost-comparison-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft lg:mx-auto lg:max-w-3xl">
          Before evaluating a new system, consider the full cost of existing energy — beyond
          electricity bills.<br className="hidden lg:block" /> A meaningful comparison includes both upfront investment and ongoing operating costs.
        </p>
      </motion.div>

      <div className="mt-10 grid grid-cols-1 gap-10 border-t border-borderLight pt-10 sm:grid-cols-2 sm:divide-x sm:divide-borderLight lg:mt-12 lg:gap-16 lg:pt-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          data-testid="cost-comparison-current"
        >
          <span className="text-xs font-medium uppercase tracking-[0.12em] text-inkMuted">
            {COST_COMPARISON.current.title}
          </span>
          <span className="mt-1.5 block text-sm font-medium text-teal">{COST_COMPARISON.current.subtitle}</span>
          <ul className="mt-6 space-y-4">
            {COST_COMPARISON.current.items.map((item) => (
              <li key={item} className="text-base text-ink lg:text-lg">
                {item}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0.08 }}
          data-testid="cost-comparison-hybrid"
          className="sm:pl-10 lg:pl-16"
        >
          <span className="text-xs font-medium uppercase tracking-[0.12em] text-inkMuted">
            {COST_COMPARISON.hybrid.title}
          </span>
          <span className="mt-1.5 block text-sm font-medium text-teal">{COST_COMPARISON.hybrid.subtitle}</span>
          <ul className="mt-6 space-y-4">
            {COST_COMPARISON.hybrid.items.map((item) => (
              <li key={item} className="text-base text-ink lg:text-lg">
                {item}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);
